module.exports = __webpack_public_path__ + "static/media/apis.684fa8b7.png";